import {
  ICompetitorsSnapshot,
  TCompetitorsSnapshot,
  TCompetitorsSnapshotKeys,
} from 'legacy/lut/classes/models/partner360/ELT/IELTFinancialData'
import { ICompetitor } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'

import { getFormedEltTranslationForKeys } from '../../../helpers/getFormedEltTranslationForKeys'

import { getEmptyRows } from './getEmptyRows'

const getWithEmptyRowsIfNeeded = (competitors: ICompetitorsSnapshot[]) => {
  const minAndMaxLength = 3
  const currentLength = competitors.length
  const diff = minAndMaxLength - currentLength
  if (diff > 0) {
    return [...competitors, ...getEmptyRows(diff)]
  }
  return competitors
}

export const formCompetitorsFromFinancialData = (
  initialData: TCompetitorsSnapshot,
  snapshotKeys: readonly TCompetitorsSnapshotKeys[]
) => {
  const data = snapshotKeys
    .filter((key) => initialData[key] && initialData[key].length > 0)
    .map((key) => {
      const competitors = initialData[key]
      const comps: ICompetitorsSnapshot[] = competitors.map((comp) => ({
        ...comp,
        YoY: comp.YoY,
      }))
      return {
        Category: key,
        CategoryName: getFormedEltTranslationForKeys(key),
        Competitors: getWithEmptyRowsIfNeeded(comps),
      } as ICompetitor
    })

  return data
}
